import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { apiInstance } from "../../../api/api";

const IncomeStatementFYSelector = () => {
  const [financialYears, setFinancialYears] = useState([]);

  useEffect(() => {
    apiInstance.get("/financial-years/")
      .then(res => setFinancialYears(res.data));
  }, []);

  return (
    <Container className="mt-4">
      <h2 className="text-center mb-4">Select Financial Year</h2>
      <Row>
        {financialYears.map(fy => (
          <Col md={4} key={fy.id} className="mb-3">
            <Link
              to={`/accounting/reports/income-statement-historical/${fy.id}`}
              className="text-decoration-none"
            >
              <Card className="bg-info text-white">
                <Card.Body>
                  <Card.Title>{fy.name}</Card.Title>
                  <Card.Text>
                    {fy.start_date} – {fy.end_date}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Link>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default IncomeStatementFYSelector;
